module.exports = __webpack_public_path__ + "img/edit.383e74dc.svg";